import { PRIMARY_LIGHT_COLOR, PRIMARY_BLUE_COLOR, SECONDARY_JAUNE_COLOR, SECONDARY_BTN_COLOR } from '../../constants/colors';
import {FONT_FAMILY_MAIN, FONT_FAMILY_CONDENSED} from '../../constants/fonts';
export default theme => ({
  root: {
    backgroundColor: 'rgba(179,195,219,.8)'
  },
  container: {
    display: 'flex',
    flexWrap: 'wrap'
  },
  textField: {
    marginLeft: 4,
		marginRight: 4,
    width: 200,
    border: `1px solid ${PRIMARY_LIGHT_COLOR}`,
    boxSizing: "border-box",
    borderRadius: "4px",
    margin: 0,
    display: "inline-block",
    '& div': {
      display: "block"
    },
    '& input': {
      width: 200
    }
  },
  textFieldless: {
    marginLeft: 4,
    marginRight: 4,
    width: 72,
    border: `1px solid ${PRIMARY_LIGHT_COLOR}`,
    boxSizing: "border-box",
    borderRadius: "4px",
    margin: 0,
    display: "inline-block",
    '& div': {
      display: "block"
    },
    '& input': {
      width: 72
    }
  },
  menu: {
    width: 400,
  },
  label:{
    fontFamily: FONT_FAMILY_MAIN,
    fontSize: "16px",
    fontWeight: "normal",
    color: PRIMARY_BLUE_COLOR,
    lineHeight: 3,
    width: "70px"
  },
  labelWarning:{
    fontWeight:300,
    color:"red",
    textAlign:"center"
  },
  button: {
    width: "171px",
    height: "37px",
    borderRadius: "20px",
    padding: "0 10px",
    margin: "5px",
    textTransform: "none !important",
    '& span': {
      fontFamily: FONT_FAMILY_MAIN,
      fontSize: "16px",
      color: PRIMARY_BLUE_COLOR,
      fontWeight: 500
    }
  },
  primaryButton: {
    background: `${SECONDARY_JAUNE_COLOR} !important`
  },
  secondaryButton: {
    background: `${SECONDARY_BTN_COLOR} !important`,
    border: `1.2px solid ${PRIMARY_BLUE_COLOR}`
  },
  justifyContent: {
    justifyContent: "center",
  },
  margin: {
    margin: "1em 12em",
  },
  width :{
    maxWidth : 660,
    margin : "0 auto" 
  },
  dialogTitle: {
    '& h2': {
      fontSize: "30px",
      fontWeight: "bold",
      fontFamily: FONT_FAMILY_CONDENSED,
      color: PRIMARY_BLUE_COLOR
    }
  },
  dialogWindow: {
    maxWidth: "720px",
    width: "720px",
    background: "#FFFFFF",
    borderRadius: "4px"
  },
  dialogContent: {
    overflow: "hidden"
  }

});


// WEBPACK FOOTER //
// ./src/opencell/pages/client/customMaterialUIStyle.js